import React, { useContext } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { AuthContext } from '../context/Auth'
import Layout from '../components/Layout'

// Só entra logado e admin; as telas ficam dentro do layout com o menu flutuante
export const PrivateRoute = () => {
    const { signed, isAdmin } = useContext(AuthContext)

    return signed && isAdmin ? <Layout><Outlet /></Layout> : <Navigate to='/' />
}
